import { useEffect } from "react";

interface SearchInterceptProps {
  onSearch?: () => void;
  disableNative?: boolean;
}
export const useSearchIntercept = ({
  onSearch,
  disableNative,
}: SearchInterceptProps) => {
  useEffect(() => {
    const interceptSearch = (event: KeyboardEvent) => {
      if (event.key === "f" && (event.ctrlKey || event.metaKey)) {
        disableNative && event.preventDefault();
        onSearch && onSearch();
      }
    };

    window.addEventListener("keydown", interceptSearch);
    return () => window.removeEventListener("keydown", interceptSearch);
  }, [disableNative, onSearch]);
};
